<template>
  <table v-if="log && log.length">
    <tr>
      <th>Date</th>
      <th>Identifiant</th>
      <th>IP</th>
      <th>Action</th>
    </tr>
    <tr v-for="line of log" :key="line.date">
      <td>{{ idyuFormatDate(line.date) }}</td>
      <td>{{ line.pseudo }}</td>
      <td>{{ line.ip }}</td>
      <td>{{ line.typeString }}</td>
    </tr>
  </table>

  <div v-else>
    <i>&#9888; Aucun log de connexion pour cet utilisateur</i>
  </div>
</template>

<script>
import { idyuJsonRpc } from "../../assets/js/idyu/connect";
import { idyuFormatDate } from "../../assets/js/idyu/util";

export default {
  props: ["id"],
  data() {
    return {
      log: null
    };
  },

  async created() {
    try {
      this.log = await idyuJsonRpc("getConnectionLog", this.id);
    } catch {
      this.log = null;
    }
  },

  methods: {
    idyuFormatDate: idyuFormatDate
  }
};
</script>
